export const RED = "#ff0000";
export const BLACK = "#000000";
export const WHITE = "#ffffff";
export const BLUE = "#0000ff";
export const GRAY = "#6b6b6b";
export const MAGENTA = "#FF00FF";
